import { render, staticRenderFns } from "./LocationWidgetContent.vue?vue&type=template&id=1956b7be&scoped=true"
import script from "./LocationWidgetContent.vue?vue&type=script&lang=js"
export * from "./LocationWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./LocationWidgetContent.vue?vue&type=style&index=0&id=1956b7be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956b7be",
  null
  
)

export default component.exports